import type {
  CarrierService,
  CarrierServiceApi,
  CarrierServiceFilters,
  CarrierServiceFiltersUpdateApi,
  CarrierServices,
  CarrierServicesApi,
} from '../../models';
import { inlineSearch, paginate } from '../normalize';

export const normalizeCarrierService = (carrierService: CarrierServiceApi): CarrierService => ({
  ...carrierService,
  id: String(carrierService.serviceKey),
  label: carrierService.description,
});

export const normalizeCarrierServices = (response: CarrierServicesApi): CarrierServices => {
  const list = (response.items ?? []).map(normalizeCarrierService);
  return {
    list,
    map: list.reduce(
      (acc, carrierService) => {
        acc[String(carrierService.id)] = carrierService;
        return acc;
      },
      {} as CarrierServices['map'],
    ),
  };
};

export const normalizeCarrierServiceFilters = (
  filters: Partial<CarrierServiceFilters>,
): CarrierServiceFiltersUpdateApi => {
  const { search, ...otherFilters } = filters;
  return {
    ...inlineSearch(search),
    ...inlineSearch(otherFilters),
    ...paginate(otherFilters),
  };
};
